import React from 'react';
import './firstpage.css';
import {
    useNavigate
  } from "react-router-dom";
import { useTranslation } from 'react-i18next';



export function FirstPage () {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
      <>
        <div className="first-page-box first-page-top-box">
                <span className="main-title">Ring<br/>Generation</span>
        </div>
        
        <div className="box">

        <div className="container">
          <button onClick={() => navigate("./login")} className="first-page-button login-button">
            {t("login")}
          </button>
          <button onClick={() => navigate("./sign_up")} className="first-page-button signup-button">
            {t("sign_up")}
          </button>
        </div>
        </div>

      </>
    );
  }